module.exports = "<span>\r\n    {{ $ctrl.date | date: $ctrl.format }}\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-date/rw-date.html
// module id = 1924
// module chunks = 0